import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { StatusBadge } from "./StatusBadge";
import { cn } from "@/lib/utils";

export function MetricCard({ metricKey, label, value, unit, period, freshness, definition, onClick, accent = "navy", sublabel }) {
  const unavailable = value === null || value === undefined;
  const display = unavailable ? "—" : typeof value === "number" ? value.toLocaleString("en-US") : value;
  return (
    <div className={cn("tqi-card relative overflow-hidden p-5 tqi-rise", accent === "red" ? "tqi-accent-red" : "tqi-accent-navy")} data-testid={`metric-card-${metricKey}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="tqi-eyebrow">{label}</span>
        {definition && (
          <TooltipProvider delayDuration={100}>
            <Tooltip>
              <TooltipTrigger asChild><button className="text-slate-400 hover:text-[#101C47]" aria-label="Definition" data-testid={`metric-definition-${metricKey}`}><HelpCircle className="h-4 w-4" /></button></TooltipTrigger>
              <TooltipContent className="max-w-xs text-xs leading-relaxed">{definition}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <button onClick={onClick} disabled={!onClick || unavailable} data-testid={`metric-drilldown-${metricKey}`}
        className={cn("mt-2 block text-left font-mono tracking-tight", unavailable ? "text-xl font-semibold text-slate-400" : "text-3xl font-bold text-slate-900", onClick && !unavailable && "hover:text-[#F92626] transition-colors")}>
        {display}{!unavailable && unit && <span className="ml-1 text-sm font-semibold text-slate-500">{unit}</span>}
      </button>
      {sublabel && <div className="mt-1 text-xs text-slate-500">{sublabel}</div>}
      {unavailable && <div className="mt-1 text-xs text-slate-500" data-testid={`metric-unavailable-${metricKey}`}>Unavailable — no source data for this period (never shown as zero)</div>}
      <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-slate-500">
        {period && <span data-testid={`metric-period-${metricKey}`}>{period}</span>}
        {freshness && <StatusBadge status={freshness.status} label={freshness.label} testId={`metric-freshness-${metricKey}`} />}
      </div>
    </div>
  );
}
